import { IconButton } from "@mui/material";
import { IMenuTableAction, RowData } from "../types/tableProps";

interface ITableActionsInline {
    actions: IMenuTableAction[];
    rowData: RowData;
}

export function TableActionsInline({
    actions,
    rowData,
}: ITableActionsInline) {
    return (
        <div className="flex gap-2 items-center justify-center">
            {actions
                .filter(act => act.showAction && act.showAction(rowData))
                .sort((a, b) => a.title.localeCompare(b.title))
                .map((act, index) => (
                    <IconButton
                        key={index}
                        onClick={() => act.act(rowData)}
                    >
                        <span
                            key={`${act.title} - ${index}`}
                            className="material-symbols-outlined cursor-pointer"
                            style={{ color: `${act.color ? act.color : 'var(--primary-color)'}` }}
                        >
                            {act.icon}
                        </span>
                    </IconButton>
                ))}
        </div>
    );
}
